import { ApolloClient, createHttpLink, InMemoryCache, } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { isEqual } from 'lodash';
export function createApolloClient(uri, getAccessToken) {
    const httpLink = createHttpLink({ uri });
    const authLink = setContext(async (_, { headers }) => {
        const accessToken = await getAccessToken();
        return {
            headers: {
                ...headers,
                Authorization: accessToken,
            },
        };
    }).concat(httpLink);
    return new ApolloClient({
        link: authLink,
        cache: new InMemoryCache(),
        defaultOptions: {
            watchQuery: {
                fetchPolicy: 'cache-and-network',
            },
            query: {
                fetchPolicy: 'network-only',
            },
            mutate: {
                fetchPolicy: 'network-only',
            },
        },
    });
}
export function getAppSyncError(apolloError, path) {
    if (apolloError?.graphQLErrors) {
        const pathParts = path.split('.');
        return apolloError.graphQLErrors.find((error) => isEqual(error.path, pathParts));
    }
    return undefined;
}
